/**
 @ngdoc service
 @name mapHistoryCandidateTileService
 @description
 factory used by mapTilesJsonData.js to construct tile data into tileData object
 */

(function() {
    'use strict';

    var mapHistoryCandidateTileService = function(tileDataFactory) {

        // Setting used field keys, to ignore when adding rest of fields to columns
        var usedFieldKeys = [].concat(tileDataFactory.HISTORY_TILE.COMMON_USED_FIELD_LIST);

        var map = function(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData){
            var self = this;
            // Assigning tile factory function with parameters to variable
            var tileFactory = new tileDataFactory.constructTileData(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData);

            tileFactory.addHistoryTimeStamp(tileFactory.historyTimeStamp.newHistoryTimeStamp('occurredOn'));
            tileFactory.addAllFieldsWithLabels(rawTileData, objectTilesLabels, usedFieldKeys, tileDataFactory.HISTORY_TILE.PRIORITY_LIST);
            //tileFactory.addTextField(tileFactory.textField.newTextField('emailContent'));

            return tileFactory.tileData;

        };

        return {
            map : map
        };
    };

    mapHistoryCandidateTileService.$inject = ['tileDataFactory'];
    angular.module('app').factory('mapHistoryCandidateTileService', mapHistoryCandidateTileService);
}());